<template>
    <div class="bar">
        <div v-if="categories.length > 0" :id="id" :style="{ width: '100%', height: height + 'px' }"></div>
        <el-empty v-else></el-empty>
    </div>
</template>

<script>
var clickIndex
var option = {
    color: ['#FF9A25', '#6E80FF', '#8B69F7', '#3AC421', '#5BAAF9'],
    tooltip: {
        trigger: 'axis',
        axisPointer: {
            type: 'shadow'
        },
        formatter (params) {
            clickIndex = params[0].dataIndex
            let str = ''
            str += `<div>${params[0].name}</div>`
            for (let i = 0; i < params.length; i += 1) {
                str += `${params[i].marker}  <span>${params[i].seriesName}</span> : <span>${params[i].data ? Math.round(params[i].data) : '0'
                    }</br>`
            }
            return str
        },
    },

    legend: {
        icon: 'rect',
        bottom: -5,
        itemWidth: 8,
        itemHeight: 8,
        itemStyle: {
            borderWidth: 5,
        }
    },

    // formatter: val => {
    //     //获取当前阴影部分点击的索引值并
    //     clickIndex = val[0].dataIndex
    //     return val
    // },
    grid: {
        left: '3%',
        right: '4%',
        bottom: '8%',
        containLabel: true,
    },
    yAxis: {
        type: 'value',
        name: '数量/人次',
        axisLine: {
            show: false,
        },
        axisTick: {
            show: false
        },
        splitLine: {
            lineStyle: {
                type: 'dashed'
            }
        },

    },
    xAxis: {
        type: 'category',
        triggerEvent: true,
        data: ['Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat', 'Sun'],
        axisLine: {
            show: false,
        },
        axisTick: {
            show: false
        },
        axisLabel: {
            // width:4,
            interval: 0,//横轴信息全部显示
            clickable: true,
        },
        axisPointer: {
            show: true,
            type: 'shadow'
        }
    },
    series: [
        {
            name: '优++',
            type: 'bar',
            stack: 'total',
            emphasis: {
                focus: 'series'
            },

            // barWidth:'32px',
            barMaxWidth: 32,
            data: [320, 302, 301, 334, 390, 330, 320]
        },
        {
            name: '优+',
            type: 'bar',
            stack: 'total',
            emphasis: {
                focus: 'series'
            },
            barMaxWidth: '32px',
            // barGap: '32px',
            // barCategoryGap: '40px',
            data: [120, 132, 101, 134, 90, 230, 210]
        },
        {
            name: '优',
            type: 'bar',
            stack: 'total',
            emphasis: {
                focus: 'series'
            },
            barMaxWidth: '32px',
            data: [220, 182, 191, 234, 290, 330, 310]
        },
        {
            name: '良+',
            type: 'bar',
            stack: 'total',
            emphasis: {
                focus: 'series'
            },
            barMaxWidth: '32px',
            data: [150, 212, 201, 154, 190, 330, 410]
        },
        {
            name: '良',
            type: 'bar',
            stack: 'total',
            emphasis: {
                focus: 'series'
            },
            barMaxWidth: '32px',
            data: [820, 832, 901, 934, 1290, 1330, 1320]
        }
    ]
}
export default {
    data () {
        return {
            myChart: '',
        }
    },
    props: {
        id: {
            type: String,
            default: 'bar'
        },
        width: {
            type: Number,
            default: 500
        },
        height: {
            type: Number,
            default: 350
        },
        categories: {
            type: Array,
            default: []
        },
        series: {
            type: Array,
            default: []
        }

    },
    watch: {
        categories (val) {
            if (val.length) {
                this.initChart()
            }

        }
    },
    mounted () {
        this.initChart()
    },
    methods: {
        initChart () {
            let that = this
            var chartDom = document.getElementById(this.id)
            this.myChart = this.$echarts.init(chartDom)

            for (let i = 0; i < that.series.length; i++) {
                option.series[i].data = that.series[i].data
            }
            this.myChart.setOption(option)
            window.onresize = this.myChart.resize
            this.myChart.setOption({
                xAxis: { data: that.categories },
            })

            this.myChart.getZr().off("click")
            // 柱状图的点击事件
            this.myChart.getZr().on('click', function (params) {
                let index
                if (params.topTarget && params.topTarget.anid) {
                    let temp = Number(params.topTarget.anid.replace('label_', ''))
                    index = temp
                } else {
                    index = clickIndex
                }
                that.$emit('getBarIndex', index)
            })
        }
    }

}
</script>

<style></style>


// WEBPACK FOOTER //
// src/view/Panel/houseworkStatistic/components/Bar.vue